<template>
  <AlModal
    :open-modal="showModal"
    data-testid="error-modal"
    :config="config"
    @close-modal="cancel"
    @close="cancel"
  >
    <Localization :message="body" />
  </AlModal>
</template>

<script>
import { AlModal } from "@playvox/almendra-components";
import { Translator, Localization } from "@agyletime/wfm-vue-common";

export default {
  name: "ErrorModal",
  mixins: [Translator],
  components: {
    AlModal,
    Localization,
  },
  props: {
    header: {
      type: String,
      default: "error-header",
    },
    body: {
      type: String,
      default: "error-content-failed",
    },
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    config() {
      return {
        header: this.translate(this.header),
        size: "sm",
        buttons: [
          {
            class: "is-secondary is-small",
            label: this.translate("error-continue"),
            testId: "accept",
            command: () => {
              this.continue();
            },
          },
        ],
      };
    },
  },
  methods: {
    cancel() {
      this.$emit("cancel-modal");
    },
    continue() {
      this.$emit("continue-modal");
    },
  },
};
</script>
